<template>
  <div
    ref="scrollContainer"
    class="scrollbar-hide overflow-auto"
    @mousewheel="captureVerticalScroll && onMouseWheel"
  >
    <slot />
  </div>
</template>

<script setup>
import { ref } from "vue"

defineProps({
  /**
   * Translate vertical scrolling to horizontal scrolling.
   */
  captureVerticalScroll: Boolean,
})

const scrollContainer = ref()

function onMouseWheel(event) {
  scrollContainer.value.scrollLeft += event.deltaY / 2
  const canScroll =
    event.deltaY < 0
      ? scrollContainer.value.scrollLeft > 0
      : scrollContainer.value.scrollLeft + scrollContainer.value.clientWidth <
        scrollContainer.value.scrollWidth
  if (canScroll && event.deltaY !== 0) {
    event.preventDefault()
  }
}

function resetPosition() {
  if (scrollContainer.value) {
    scrollContainer.value.scrollTo(0, 0)
  }
}

defineExpose({
  resetPosition,
})
</script>
